module.exports = __webpack_public_path__ + "static/media/mexico.0b8c1db9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/assets/mexico.svg
// module id = 122
// module chunks = 0